// Generated by Melange

import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function Licenses(Props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h2", {
        children: "Лицензии",
        className: "h4 lg:h2 text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "Мы имеем лицензии на оказание бухгалтерских и финансовых услуг.",
        className: "paragraph text-black-landing mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h6", {
                children: "Licence For Carrying On Ancillary Services",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "PDF ･ 164 KB",
                className: "paragraph text-gray-landing mt-1"
              }),
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx("img", {
                  alt: "license",
                  src: StaticAsset.src("/static/images/license.png")
                }),
                className: "mt-6 block",
                href: "https://static.buhtacdn.com/content/legal/AFSA-A-LA-2022-0009.pdf",
                target: "_blank"
              })
            ],
            className: "w-full bg-bg rounded-lg p-6 mt-6 lg:mt-10"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h6", {
                children: "Лицензия на осуществление микрофинансовой деятельности",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "PDF ･ 213 KB",
                className: "paragraph text-gray-landing mt-1"
              }),
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx("img", {
                  alt: "license2",
                  src: StaticAsset.src("/static/images/license-mfo.png")
                }),
                className: "mt-6 block shadow-kkm",
                href: "https://static.buhtacdn.com/content/legal/license-mfo.pdf",
                target: "_blank"
              })
            ],
            className: "w-full bg-bg rounded-lg p-6 mt-6 lg:mt-10"
          })
        ],
        className: ""
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-6 lg:mt-10"
      }),
      JsxRuntime.jsxs("p", {
        children: [
          "По вопросам сотрудничества и партнерства пишите на ",
          JsxRuntime.jsx("a", {
            children: "hello@buhta.com",
            className: "text-primary underline",
            href: "mailto:hello@buhta.com"
          })
        ],
        className: "paragraph-small lg:paragraph text-black-landing mt-6 lg:mt-10"
      })
    ],
    className: "pt-10 lg:pt-0 px-6 sm:px-48 lg:px-0"
  });
}

const make = Licenses;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
